module.exports = __webpack_public_path__ + "img/kaistee.b49ca76a.svg";